import React from 'react';
import PropTypes from 'prop-types';
import b_ from 'b_';
import cn from 'classnames';
import InputStore from '../../stores/InputStore';
import { ObservableTextfield } from '../Textfield';
import './PasteLimitField.css';

const block = b_.lock('PasteLimitField');

function PasteLimitField({ store, disabled, infoCls, info, fieldCls, inputCls }) {
    return (
        <div className={block()}>
            <ObservableTextfield
                type="number"
                className={cn(block('Field'), fieldCls)}
                inputClassName={cn(block('Input'), inputCls)}
                store={store}
                error={!store.isValid}
                min={0}
                max={99999}
                step={1}
                disabled={disabled}
            />

            <div className={cn(block('Info'), infoCls)}>{ info || 'characters' }</div>
        </div>
    );
}

PasteLimitField.propTypes = {
    store: InputStore.PropType.isRequired,
    disabled: PropTypes.bool,
    fieldCls: PropTypes.string,
    info: PropTypes.string,
    infoCls: PropTypes.string,
    inputCls: PropTypes.string
};

export default PasteLimitField;
